export const Avatar = ({ children }) => {
  return (
    <div className="avatar user-select-none border border-1">
      {children}
    </div>
  );
};
